import { Button, Col, Form, Row, Select, Space, Spin } from 'antd';
import { type DefaultOptionType } from 'antd/lib/select';
import React from 'react';

import { getFilterOption, getFilterSort } from '../../fragments/select-filter';
import { SPACING } from '../../theme/tokens';

export interface IDescriptionProduct extends DefaultOptionType {
  value: string;
  label: string;
}

interface IFormCopy {
  productSourceUUID: string;
}

export default function CopyDescriptionsForm({
  copyDescriptionProducts,
  onSubmit,
  inProcess,
}: {
  copyDescriptionProducts: IDescriptionProduct[];
  onSubmit: (productSourceUUID: string) => void;
  inProcess: boolean;
}): React.ReactElement {
  const [form] = Form.useForm<IFormCopy>();

  return (
    <Form
      form={form}
      onFinish={({ productSourceUUID }: IFormCopy): void =>
        onSubmit(productSourceUUID)
      }
      layout="vertical"
      disabled={inProcess}
    >
      <Row gutter={SPACING.lg}>
        <Col span={6} offset={15}>
          <Form.Item
            name="productSourceUUID"
            rules={[{ required: true }, { type: 'string', min: 36 }]}
            label="Product source"
          >
            <Select
              allowClear
              placeholder="Select source product"
              showSearch={{
                filterOption: getFilterOption,
                filterSort: getFilterSort,
              }}
              options={copyDescriptionProducts}
            />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Space size={SPACING.lg} align="start">
            <Button type="primary" htmlType="submit">
              Copy descriptions
            </Button>
            <Spin size="small" spinning={inProcess} />
          </Space>
        </Col>
      </Row>
    </Form>
  );
}
